import { Button, ButtonLink } from '@packages/shared/src/ui/Button/Button';
import { defineMessages, useIntl } from 'react-intl';
import { LoginDialogComposed } from '@packages/modules/src/LoginDialog/LoginDialogComposed/LoginDialogComposed';

const messages = defineMessages({
  emptyBasketHeadline: {
    id: 'BasketEmpty.Headline',
    defaultMessage: 'Dein Warenkorb ist leer',
  },
  loggedInInfoText: {
    id: 'BasketEmpty.LoggedIn.InfoText',
    defaultMessage:
      'Du vermisst Artikel, die du bereits in den Warenkorb gelegt hast? Dann melde dich bitte an, um deine gespeicherten Artikel zu sehen.',
  },
  loggedOutInfoText: {
    id: 'BasketEmpty.LoggedOut.InfoText',
    defaultMessage:
      'Du vermisst Artikel, die du bereits in den Warenkorb gelegt hast? Dann melde dich bitte an, um deine gespeicherten Artikel zu sehen.',
  },
  emptyBasketButton: {
    id: 'BasketEmpty.GoToShop',
    defaultMessage: 'Weiter im Shop',
  },
  loginBasketButton: {
    id: 'BasketEmpty.Login',
    defaultMessage: 'Anmelden',
  },
});
export const BasketEmpty: React.FC<{ loggedIn?: boolean }> = ({ loggedIn }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="max-w-[49.625rem]" data-testid="basket-empty-wrapper">
      <div className="bg-color-grey-light mb-2.5 flex flex-col items-center justify-between p-[1.25rem_0.75rem_1.75rem] text-center md:p-[1.25rem_1.75rem_3rem]">
        <div className="icon-emp-cart size-[5rem]" />
        <div className="text-size-h4 md:text-size-h3 mt-2.5 mb-1 md:mb-1.5">
          {formatMessage(messages.emptyBasketHeadline)}
        </div>
        <div className="text-size-body-base mb-3.5 md:mb-6">
          {loggedIn && formatMessage(messages.loggedInInfoText)}
          {!loggedIn && formatMessage(messages.loggedOutInfoText)}
        </div>
        <div className="flex w-auto max-w-full flex-col-reverse justify-around gap-1.5 md:w-full md:flex-row">
          <ButtonLink
            color={loggedIn ? 'primary' : undefined}
            size="large"
            href="/"
            className="w-[21.938rem] max-w-full"
          >
            {formatMessage(messages.emptyBasketButton)}
          </ButtonLink>
          {!loggedIn && (
            <LoginDialogComposed>
              {(openDialog) => (
                <Button
                  onClick={openDialog}
                  size="large"
                  color="primary"
                  className="w-[21.938rem] max-w-full"
                >
                  {formatMessage(messages.loginBasketButton)}
                </Button>
              )}
            </LoginDialogComposed>
          )}
        </div>
      </div>
    </div>
  );
};
